var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKeyFunctionNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1093.7 181.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-5);}.cls-3{fill:url(#linear-gradient-8);}.cls-4{fill:url(#linear-gradient-9);}.cls-5{fill:#fff;}.cls-6{fill:url(#linear-gradient-16);}.cls-7{fill:url(#linear-gradient-17);}.cls-8{fill:url(#linear-gradient-19);}.cls-9{fill:url(#linear-gradient-20);}.cls-10{fill:url(#linear-gradient-21);}.cls-11{fill:url(#linear-gradient-22);}.cls-12{fill:url(#linear-gradient-23);}.cls-13{fill:url(#linear-gradient-24);}.cls-14{fill:url(#linear-gradient-25);}.cls-15{fill:url(#linear-gradient-26);}.cls-16{fill:url(#linear-gradient-27);}.cls-17{fill:url(#linear-gradient-29);}.cls-18{fill:url(#linear-gradient-30);}.cls-19{fill:url(#linear-gradient-31);}.cls-20{fill:url(#linear-gradient-33);}.cls-21{fill:url(#linear-gradient-34);}.cls-22{fill:url(#linear-gradient-35);}.cls-23{fill:url(#linear-gradient-36);}.cls-24{fill:url(#linear-gradient-37);}.cls-25{fill:url(#linear-gradient-38);}.cls-26{fill:url(#linear-gradient-39);}.cls-27{fill:url(#linear-gradient-40);}.cls-28{fill:url(#linear-gradient-41);}.cls-29{fill:url(#linear-gradient-42);}.cls-30{fill:url(#linear-gradient-43);}.cls-31{fill:url(#linear-gradient-44);}.cls-32{fill:url(#linear-gradient-45);}.cls-33{fill:url(#linear-gradient-46);}.cls-34{fill:url(#linear-gradient-47);}.cls-35{fill:url(#linear-gradient-48);}.cls-36{fill:url(#linear-gradient-49);}.cls-37{fill:url(#linear-gradient-50);}.cls-38{fill:url(#linear-gradient-51);}.cls-39{fill:url(#linear-gradient-52);}.cls-40{fill:url(#linear-gradient-53);}.cls-41{fill:url(#linear-gradient-54);}.cls-42{fill:url(#linear-gradient-56);}.cls-43{fill:url(#linear-gradient-57);}.cls-44{fill:url(#linear-gradient-58);}.cls-45{fill:url(#linear-gradient-60);}.cls-46{fill:url(#linear-gradient-61);}.cls-47{fill:url(#linear-gradient-62);}.cls-48{fill:url(#linear-gradient-64);}.cls-49{fill:url(#linear-gradient-65);}.cls-50{fill:url(#linear-gradient-66);}.cls-51{fill:url(#linear-gradient-68);}.cls-52{fill:url(#linear-gradient-69);}.cls-53{fill:url(#linear-gradient-70);}.cls-54{fill:url(#linear-gradient-71);}.cls-55{fill:url(#linear-gradient-72);}.cls-56{fill:url(#linear-gradient-73);}.cls-57{fill:url(#linear-gradient-74);}.cls-58{fill:url(#linear-gradient-75);}.cls-59{fill:url(#linear-gradient-76);}.cls-60{fill:url(#linear-gradient-77);}.cls-61{fill:url(#linear-gradient-78);}.cls-62{fill:url(#linear-gradient-79);}.cls-63{fill:url(#linear-gradient-80);}.cls-64{fill:url(#linear-gradient-81);}.cls-65{fill:url(#linear-gradient-82);}.cls-66{fill:url(#linear-gradient-83);}.cls-67{fill:url(#linear-gradient-85);}.cls-68{fill:url(#linear-gradient-86);}.cls-69{fill:url(#linear-gradient-87);}.cls-70{fill:url(#linear-gradient-88);}.cls-71{fill:url(#linear-gradient-89);}.cls-72{fill:url(#linear-gradient-90);}.cls-73{fill:url(#linear-gradient-91);}.cls-74{fill:url(#linear-gradient-92);}.cls-75{fill:url(#linear-gradient-93);}.cls-76{fill:url(#linear-gradient-94);}.cls-77{fill:url(#linear-gradient-95);}.cls-78{fill:url(#linear-gradient-96);}.cls-79{fill:url(#linear-gradient-97);}.cls-80{fill:url(#linear-gradient-98);}.cls-81{fill:url(#linear-gradient-99);}.cls-82{fill:url(#linear-gradient-100);}.cls-83{fill:url(#linear-gradient-101);}.cls-84{fill:url(#linear-gradient-102);}.cls-85{fill:url(#linear-gradient-104);}.cls-86{fill:url(#linear-gradient-105);}.cls-87{fill:url(#linear-gradient-106);}.cls-88{fill:url(#linear-gradient-107);}.cls-89{fill:url(#linear-gradient-108);}.cls-90{fill:url(#linear-gradient-110);}.cls-91{fill:url(#linear-gradient-111);}.cls-92{fill:url(#linear-gradient-112);}.cls-93{fill:url(#linear-gradient-114);}.cls-94{fill:url(#linear-gradient-115);}.cls-95{fill:url(#linear-gradient-116);}.cls-96{fill:url(#linear-gradient-118);}.cls-97{fill:url(#linear-gradient-119);}.cls-98{fill:url(#linear-gradient-120);}.cls-99{fill:url(#linear-gradient-122);}.cls-100{fill:url(#linear-gradient-123);}.cls-101{fill:url(#linear-gradient-124);}.cls-102{fill:url(#linear-gradient-125);}.cls-103{fill:url(#linear-gradient-126);}.cls-104{fill:url(#linear-gradient-129);}.cls-105{fill:url(#linear-gradient-130);}.cls-106{fill:url(#linear-gradient-132);}.cls-107{fill:url(#linear-gradient-133);}.cls-108{fill:url(#linear-gradient-134);}.cls-109{fill:url(#linear-gradient-136);}.cls-110{fill:url(#linear-gradient-137);}.cls-111{fill:url(#linear-gradient-138);}.cls-112{fill:url(#linear-gradient-139);}.cls-113{fill:url(#linear-gradient-140);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 50.23,
    y1: 176.04,
    x2: 1041.88,
    y2: 176.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#3ac2d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#39bfd7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2a8fd7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 50.22,
    y1: 176.04,
    x2: 1041.87,
    y2: 176.04,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 49.88,
    y1: 90.34,
    x2: 1041.53,
    y2: 90.34,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 50.23,
    y1: 5.66,
    x2: 1041.88,
    y2: 5.66,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 217.25,
    y1: 30.35,
    x2: 217.25,
    y2: 132.24,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 216.41,
    y1: 30.35,
    x2: 216.41,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 188.16,
    y1: 30.35,
    x2: 188.16,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 244.32,
    y1: 30.35,
    x2: 244.32,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 243.46,
    y1: 30.35,
    x2: 243.46,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 216.41,
    y1: 30.33,
    x2: 216.41,
    y2: 132.28,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 234.4,
    y1: 30.35,
    x2: 234.4,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 198.57,
    y1: 30.35,
    x2: 198.57,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 218.47,
    y1: 30.35,
    x2: 218.47,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 247.02,
    y1: 30.35,
    x2: 247.02,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 188.2,
    y1: 30.35,
    x2: 188.2,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 186.49,
    y1: 30.35,
    x2: 186.49,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 713.15,
    y1: 30.35,
    x2: 713.15,
    y2: 132.24,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 712.11,
    y1: 30.35,
    x2: 712.11,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 713.19,
    y1: 30.35,
    x2: 713.19,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 744.92,
    y1: 30.35,
    x2: 744.92,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 677.98,
    y1: 30.35,
    x2: 677.98,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 683.39,
    y1: 30.35,
    x2: 683.39,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 688.79,
    y1: 30.35,
    x2: 688.79,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 694.2,
    y1: 30.35,
    x2: 694.2,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 699.6,
    y1: 30.35,
    x2: 699.6,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 705.01,
    y1: 30.35,
    x2: 705.01,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 710.41,
    y1: 30.35,
    x2: 710.41,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 715.81,
    y1: 30.35,
    x2: 715.81,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 721.22,
    y1: 30.35,
    x2: 721.22,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 726.62,
    y1: 30.35,
    x2: 726.62,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 732.03,
    y1: 30.35,
    x2: 732.03,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 737.43,
    y1: 30.35,
    x2: 737.43,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 742.83,
    y1: 30.35,
    x2: 742.83,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 748.24,
    y1: 30.35,
    x2: 748.24,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 877.45,
    y1: 30.35,
    x2: 877.45,
    y2: 132.24,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 877.8,
    y1: 30.35,
    x2: 877.8,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 862.05,
    y1: 30.35,
    x2: 862.05,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 893.68,
    y1: 30.35,
    x2: 893.68,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 849.58,
    y1: 30.35,
    x2: 849.58,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 849.61,
    y1: 30.35,
    x2: 849.61,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 848.03,
    y1: 30.35,
    x2: 848.03,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 905.32,
    y1: 30.35,
    x2: 905.32,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 905.36,
    y1: 30.35,
    x2: 905.36,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 903.78,
    y1: 30.35,
    x2: 903.78,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 865.53,
    y1: 30.35,
    x2: 865.53,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 865.56,
    y1: 30.35,
    x2: 865.56,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 863.98,
    y1: 30.35,
    x2: 863.98,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 889.81,
    y1: 30.35,
    x2: 889.81,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 889.84,
    y1: 30.35,
    x2: 889.84,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 888.26,
    y1: 30.35,
    x2: 888.26,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 866.16,
    y1: 30.35,
    x2: 866.16,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 888.94,
    y1: 30.35,
    x2: 888.94,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 875.78,
    y1: 30.35,
    x2: 875.78,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: 855.29,
    y1: 30.35,
    x2: 855.29,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: 877.51,
    y1: 30.35,
    x2: 877.51,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 903.5,
    y1: 30.35,
    x2: 903.5,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: 546.85,
    y1: 30.35,
    x2: 546.85,
    y2: 132.24,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: 531.74,
    y1: 30.35,
    x2: 531.74,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 520.18,
    y1: 30.35,
    x2: 520.18,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 523.19,
    y1: 30.35,
    x2: 523.19,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 522.62,
    y1: 30.35,
    x2: 522.62,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 547.46,
    y1: 30.35,
    x2: 547.46,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: 547.53,
    y1: 30.35,
    x2: 547.53,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: 547.32,
    y1: 30.35,
    x2: 547.32,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: 547.39,
    y1: 30.35,
    x2: 547.39,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: 565.48,
    y1: 30.35,
    x2: 565.48,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: 565.19,
    y1: 30.35,
    x2: 565.19,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: 566.39,
    y1: 30.35,
    x2: 566.39,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: 566.41,
    y1: 30.35,
    x2: 566.41,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: 564.18,
    y1: 30.35,
    x2: 564.18,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    x1: 565.6,
    y1: 30.35,
    x2: 565.6,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: 571.56,
    y1: 30.35,
    x2: 571.56,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: 571.71,
    y1: 30.35,
    x2: 571.71,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: 532.84,
    y1: 30.35,
    x2: 532.84,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: 383.55,
    y1: 30.35,
    x2: 383.55,
    y2: 132.24,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: 381.96,
    y1: 30.35,
    x2: 381.96,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: 356.94,
    y1: 30.35,
    x2: 356.94,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: 355.38,
    y1: 30.35,
    x2: 355.38,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: 358.91,
    y1: 30.35,
    x2: 358.91,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: 406.15,
    y1: 30.35,
    x2: 406.15,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: 407.71,
    y1: 30.35,
    x2: 407.71,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: 404.19,
    y1: 30.35,
    x2: 404.19,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: 381.59,
    y1: 30.35,
    x2: 381.59,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: 382.14,
    y1: 30.35,
    x2: 382.14,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: 382.15,
    y1: 30.35,
    x2: 382.15,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: 50.95,
    y1: 30.35,
    x2: 50.95,
    y2: 132.24,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-107",
    x1: 23.2,
    y1: 30.35,
    x2: 23.2,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-108",
    x1: 23.24,
    y1: 30.35,
    x2: 23.24,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-110",
    x1: 21.58,
    y1: 30.35,
    x2: 21.58,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-111",
    x1: 41.7,
    y1: 30.35,
    x2: 41.7,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-112",
    x1: 41.73,
    y1: 30.35,
    x2: 41.73,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-114",
    x1: 40.08,
    y1: 30.35,
    x2: 40.08,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-115",
    x1: 60.19,
    y1: 30.35,
    x2: 60.19,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-116",
    x1: 60.23,
    y1: 30.35,
    x2: 60.23,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-118",
    x1: 58.58,
    y1: 30.35,
    x2: 58.58,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-119",
    x1: 78.69,
    y1: 30.35,
    x2: 78.69,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-120",
    x1: 78.73,
    y1: 30.35,
    x2: 78.73,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-122",
    x1: 77.08,
    y1: 30.35,
    x2: 77.08,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-123",
    x1: 48.72,
    y1: 30.35,
    x2: 48.72,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-124",
    x1: 57.58,
    y1: 30.35,
    x2: 57.58,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-125",
    x1: 50.97,
    y1: 30.35,
    x2: 50.97,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-126",
    x1: 50.97,
    y1: 30.35,
    x2: 50.97,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-129",
    x1: 37.11,
    y1: 30.35,
    x2: 37.11,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-130",
    x1: 64.89,
    y1: 30.35,
    x2: 64.89,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-132",
    x1: 59.69,
    y1: 30.35,
    x2: 59.69,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-133",
    x1: 1042.75,
    y1: 30.35,
    x2: 1042.75,
    y2: 132.24,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-134",
    x1: 1040.06,
    y1: 30.35,
    x2: 1040.06,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-136",
    x1: 1039.73,
    y1: 30.35,
    x2: 1039.73,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-137",
    x1: 1061.18,
    y1: 30.35,
    x2: 1061.18,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-138",
    x1: 1048.36,
    y1: 30.35,
    x2: 1048.36,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-139",
    x1: 1059.84,
    y1: 30.35,
    x2: 1059.84,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-140",
    x1: 1040.06,
    y1: 30.35,
    x2: 1040.06,
    y2: 132.3,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DESIGN_ICON_Resize_mayuri",
    "data-name": "DESIGN ICON Resize mayuri"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46,172.36c-3.3,5,.86,10.29,5.77,9.2A5.61,5.61,0,0,0,56,177.34c1.09-4.92-4.21-9.08-9.19-5.78A2.9,2.9,0,0,0,46,172.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M211.24,172.36c-3.3,5,.86,10.29,5.77,9.2a5.61,5.61,0,0,0,4.22-4.22c1.09-4.92-4.21-9.08-9.19-5.78A2.9,2.9,0,0,0,211.24,172.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M378.43,172.36c-3.3,5,.86,10.29,5.78,9.2a5.61,5.61,0,0,0,4.22-4.22c1.09-4.92-4.22-9.08-9.2-5.78A3,3,0,0,0,378.43,172.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M543.37,172.36c-3.3,5,.86,10.29,5.78,9.2a5.61,5.61,0,0,0,4.22-4.22c1.09-4.92-4.21-9.08-9.2-5.78A3,3,0,0,0,543.37,172.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M708,172.36c-3.3,5,.86,10.29,5.77,9.2a5.61,5.61,0,0,0,4.22-4.22c1.09-4.92-4.21-9.08-9.19-5.78A2.9,2.9,0,0,0,708,172.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M873.91,172.36c-3.3,5,.86,10.29,5.78,9.2a5.61,5.61,0,0,0,4.22-4.22c1.09-4.92-4.22-9.08-9.2-5.78A3,3,0,0,0,873.91,172.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1038.27,172.36c-3.3,5,.86,10.29,5.78,9.2a5.61,5.61,0,0,0,4.22-4.22c1.09-4.92-4.22-9.08-9.2-5.78A3,3,0,0,0,1038.27,172.36Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "49.88 174.18 49.88 5.22 216.34 5.22 216.34 174.97 382.36 174.97 382.36 4.68 547.22 4.68 547.22 173.87 711.44 173.87 711.44 4.68 878.67 4.68 878.67 173.87 1042.34 173.87 1042.34 7.04 1043.59 8.07 1043.59 174.9 877.42 174.9 877.42 5.71 712.69 5.71 712.69 174.9 545.97 174.9 545.97 5.71 383.61 5.71 383.61 176 215.09 176 215.09 6.26 51.13 6.26 51.13 175.21 49.88 174.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M46,2c-3.3,5,.86,10.29,5.77,9.2A5.61,5.61,0,0,0,56,7C57.11,2,51.81-2.12,46.83,1.18A2.9,2.9,0,0,0,46,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M211.24,2c-3.3,5,.86,10.29,5.77,9.2A5.61,5.61,0,0,0,221.23,7C222.32,2,217-2.12,212,1.18A2.9,2.9,0,0,0,211.24,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M378.45,2c-3.31,5,.86,10.29,5.77,9.2A5.61,5.61,0,0,0,388.44,7c1.09-4.92-4.21-9.08-9.19-5.78A2.9,2.9,0,0,0,378.45,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M540.82,2c-3.3,5,.86,10.29,5.78,9.2A5.61,5.61,0,0,0,550.82,7c1.09-4.92-4.21-9.08-9.2-5.78A3,3,0,0,0,540.82,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M707.85,2c-3.3,5,.86,10.29,5.78,9.2A5.61,5.61,0,0,0,717.85,7c1.09-4.92-4.22-9.08-9.2-5.78A3,3,0,0,0,707.85,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M873.06,2c-3.3,5,.86,10.29,5.78,9.2A5.61,5.61,0,0,0,883.06,7c1.09-4.92-4.22-9.08-9.2-5.78A3,3,0,0,0,873.06,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1038.27,2c-3.3,5,.86,10.29,5.78,9.2A5.61,5.61,0,0,0,1048.27,7c1.09-4.92-4.22-9.08-9.2-5.78A3,3,0,0,0,1038.27,2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 166.3,
    y: 37.37,
    width: 101.89,
    height: 101.89,
    rx: 8.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M259.59,139.26H174.91a8.62,8.62,0,0,1-8.61-8.61V46a8.61,8.61,0,0,1,8.61-8.6h84.68a8.61,8.61,0,0,1,8.6,8.6v84.68A8.61,8.61,0,0,1,259.59,139.26ZM174.91,40.08A5.89,5.89,0,0,0,169,46v84.68a5.89,5.89,0,0,0,5.89,5.89h84.68a5.89,5.89,0,0,0,5.88-5.89V46a5.89,5.89,0,0,0-5.88-5.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M216.41,101.89a7.06,7.06,0,1,1,7.07-7.06A7.07,7.07,0,0,1,216.41,101.89Zm0-11.79a4.74,4.74,0,1,0,4.74,4.73A4.73,4.73,0,0,0,216.41,90.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M224,125.49a1.17,1.17,0,0,1-1.17-1.14l-.31-14a1.18,1.18,0,0,1,1.14-1.19l6.95-.19a7.67,7.67,0,0,0,2.81-.75l10.66-5.18a1.58,1.58,0,0,0,.72-2.14,1.56,1.56,0,0,0-2-.7l-8.92,4.17a10.09,10.09,0,0,1-4.84.92H203.81a10.13,10.13,0,0,1-4.85-.92L190,100.22a1.57,1.57,0,0,0-1.31,2.85l10.67,5.18a7.57,7.57,0,0,0,2.8.75l7,.19a1.17,1.17,0,0,1,1.13,1.19l-.31,14a1.17,1.17,0,1,1-2.33,0l.29-12.81-5.83-.16h0a10.07,10.07,0,0,1-3.68-1l-10.66-5.18a3.89,3.89,0,0,1-1.78-5.29A3.9,3.9,0,0,1,191,98.11l8.94,4.18a7.81,7.81,0,0,0,3.75.71h25.42a7.85,7.85,0,0,0,3.76-.71l8.93-4.18a3.89,3.89,0,0,1,5.08,1.76,3.83,3.83,0,0,1,.23,3,3.87,3.87,0,0,1-2,2.28l-10.66,5.17a10,10,0,0,1-3.68,1h-.05l-5.82.16.28,12.81a1.16,1.16,0,0,1-1.14,1.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M195.38,93.9H180.94a1.16,1.16,0,0,1-1.16-1.17V74.19A1.16,1.16,0,0,1,180.94,73h14.44a1.16,1.16,0,0,1,1.16,1.17V92.73A1.16,1.16,0,0,1,195.38,93.9Zm-13.27-2.33h12.1V75.35h-12.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M244.32,93.86a10.4,10.4,0,1,1,10.4-10.4A10.42,10.42,0,0,1,244.32,93.86Zm0-18.47a8.07,8.07,0,1,0,8.07,8.07A8.08,8.08,0,0,0,244.32,75.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M239.67,87a1.17,1.17,0,0,1-1-.64,6.37,6.37,0,0,1,10-7.57A1.17,1.17,0,1,1,247,80.47a4,4,0,0,0-2.7-1,4.05,4.05,0,0,0-3.62,5.85,1.16,1.16,0,0,1-.51,1.56A1.23,1.23,0,0,1,239.67,87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M216.41,71.93a10.4,10.4,0,1,1,10.4-10.4A10.41,10.41,0,0,1,216.41,71.93Zm0-18.47a8.08,8.08,0,1,0,8.07,8.07A8.08,8.08,0,0,0,216.41,53.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M238.64,71.67a1.18,1.18,0,0,1-.9-.42,27.86,27.86,0,0,0-8.13-6.68,1.16,1.16,0,1,1,1.11-2,30,30,0,0,1,8.81,7.23,1.17,1.17,0,0,1-.89,1.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M194.56,71.14a1.17,1.17,0,0,1-.76-.29,1.15,1.15,0,0,1-.11-1.64A30.06,30.06,0,0,1,202,62.53a1.16,1.16,0,0,1,1.58.47,1.18,1.18,0,0,1-.47,1.58,27.74,27.74,0,0,0-7.69,6.16A1.17,1.17,0,0,1,194.56,71.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M220.49,62.62h-4a1.16,1.16,0,0,1-1.16-1.16v-5.9a1.17,1.17,0,1,1,2.33,0v4.73h2.87a1.17,1.17,0,0,1,0,2.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M244.46,86.48a1.16,1.16,0,0,1-.58-2.17l5.12-3a1.16,1.16,0,1,1,1.16,2L245,86.32A1.1,1.1,0,0,1,244.46,86.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M191,79.93H185.4a1.17,1.17,0,0,1,0-2.33H191a1.17,1.17,0,1,1,0,2.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M191,84.35H185.4a1.16,1.16,0,1,1,0-2.32H191a1.16,1.16,0,1,1,0,2.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M187.58,88.78H185.4a1.17,1.17,0,0,1,0-2.33h2.18a1.17,1.17,0,0,1,0,2.33Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 662.2,
    y: 37.37,
    width: 101.89,
    height: 101.89,
    rx: 8.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M755.49,139.26H670.81a8.62,8.62,0,0,1-8.61-8.61V46a8.61,8.61,0,0,1,8.61-8.6h84.68A8.61,8.61,0,0,1,764.1,46v84.68A8.62,8.62,0,0,1,755.49,139.26ZM670.81,40.08A5.89,5.89,0,0,0,664.92,46v84.68a5.89,5.89,0,0,0,5.89,5.89h84.68a5.89,5.89,0,0,0,5.89-5.89V46a5.89,5.89,0,0,0-5.89-5.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M746.31,124.49a1.12,1.12,0,0,1-1.13-1.13,4.74,4.74,0,0,0-4.74-4.73,7,7,0,0,1-5-11.95A4.74,4.74,0,0,0,728.8,100h0a7,7,0,0,1-11.95-5,4.74,4.74,0,1,0-9.47,0,7,7,0,0,1-12,5h0a4.74,4.74,0,0,0-6.69,6.71h0a7,7,0,0,1-5,11.94,4.74,4.74,0,0,0-4.74,4.73,1.13,1.13,0,1,1-2.26,0,7,7,0,0,1,7-7,4.74,4.74,0,0,0,3.36-8.08h0A7,7,0,0,1,697,98.38h0A4.74,4.74,0,0,0,705.11,95a7,7,0,1,1,14,0,4.73,4.73,0,0,0,8.07,3.36h0a7,7,0,1,1,9.9,9.9,4.73,4.73,0,0,0,3.35,8.08,7,7,0,0,1,7,7A1.13,1.13,0,0,1,746.31,124.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M728.48,124.49a1.13,1.13,0,0,1-1.14-1.13,15.24,15.24,0,0,0-30.47,0,1.13,1.13,0,0,1-2.26,0,17.5,17.5,0,0,1,35,0A1.13,1.13,0,0,1,728.48,124.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M678,89.29a1.13,1.13,0,0,1-.8-1.93L688.3,76.24a1.13,1.13,0,0,1,1.41-.15l4.86,3.09L705.7,69.1a1.12,1.12,0,0,1,1.45,0l6.3,4.9L723,63.17a1.15,1.15,0,0,1,1.41-.24l7.94,4.52,15.29-15a1.13,1.13,0,0,1,1.59,1.62L733.28,69.66a1.12,1.12,0,0,1-1.35.18l-7.88-4.49-9.61,10.89a1.12,1.12,0,0,1-1.54.15l-6.39-5-11.06,10a1.14,1.14,0,0,1-1.37.12l-4.82-3.07L678.78,89A1.13,1.13,0,0,1,678,89.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M748.39,61.34a1.14,1.14,0,0,1-1.13-1.13V54.39h-5.81a1.13,1.13,0,1,1,0-2.26h6.94a1.13,1.13,0,0,1,1.13,1.13v7A1.13,1.13,0,0,1,748.39,61.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M678,102.88a1.14,1.14,0,0,1-1.13-1.13V92.33a1.13,1.13,0,0,1,2.26,0v9.42A1.13,1.13,0,0,1,678,102.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M683.39,98.24a1.12,1.12,0,0,1-1.13-1.13v-7a1.13,1.13,0,1,1,2.26,0v7A1.13,1.13,0,0,1,683.39,98.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M688.79,93.46a1.14,1.14,0,0,1-1.13-1.13V85.07a1.13,1.13,0,0,1,2.26,0v7.26A1.13,1.13,0,0,1,688.79,93.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M694.2,92.84a1.13,1.13,0,0,1-1.13-1.13V85.07a1.13,1.13,0,0,1,2.26,0v6.64A1.14,1.14,0,0,1,694.2,92.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M699.6,95.31a1.14,1.14,0,0,1-1.13-1.13V82.75a1.13,1.13,0,1,1,2.26,0V94.18A1.13,1.13,0,0,1,699.6,95.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M705,88.31a1.14,1.14,0,0,1-1.14-1.13V78.43a1.14,1.14,0,0,1,2.27,0v8.75A1.14,1.14,0,0,1,705,88.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M710.41,86.2a1.13,1.13,0,0,1-1.13-1.13V80a1.13,1.13,0,1,1,2.26,0v5.1A1.14,1.14,0,0,1,710.41,86.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M715.81,86.2a1.14,1.14,0,0,1-1.13-1.13V80a1.13,1.13,0,1,1,2.26,0v5.1A1.13,1.13,0,0,1,715.81,86.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M721.22,90.44a1.12,1.12,0,0,1-1.13-1.13V74.72a1.13,1.13,0,0,1,2.26,0V89.31A1.13,1.13,0,0,1,721.22,90.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M726.62,94.54a1.14,1.14,0,0,1-1.13-1.13V71.33a1.13,1.13,0,1,1,2.26,0V93.41A1.13,1.13,0,0,1,726.62,94.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M732,93.46a1.13,1.13,0,0,1-1.13-1.13V74.11a1.13,1.13,0,0,1,2.26,0V92.33A1.14,1.14,0,0,1,732,93.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M737.43,93.46a1.14,1.14,0,0,1-1.13-1.13v-21a1.13,1.13,0,1,1,2.26,0v21A1.13,1.13,0,0,1,737.43,93.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M742.83,102.88a1.14,1.14,0,0,1-1.13-1.13V66.08a1.14,1.14,0,0,1,2.27,0v35.67A1.14,1.14,0,0,1,742.83,102.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M748.24,102.88a1.13,1.13,0,0,1-1.13-1.13V66.08a1.13,1.13,0,0,1,2.26,0v35.67A1.14,1.14,0,0,1,748.24,102.88Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 826.51,
    y: 37.37,
    width: 101.89,
    height: 101.89,
    rx: 8.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M919.79,139.26H835.11a8.61,8.61,0,0,1-8.6-8.61V46a8.61,8.61,0,0,1,8.6-8.6h84.68A8.61,8.61,0,0,1,928.4,46v84.68A8.62,8.62,0,0,1,919.79,139.26ZM835.11,40.08A5.89,5.89,0,0,0,829.22,46v84.68a5.89,5.89,0,0,0,5.89,5.89h84.68a5.89,5.89,0,0,0,5.89-5.89V46a5.89,5.89,0,0,0-5.89-5.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M877.8,99.53A6.54,6.54,0,1,1,884.34,93,6.54,6.54,0,0,1,877.8,99.53Zm0-10.92A4.39,4.39,0,1,0,882.18,93,4.39,4.39,0,0,0,877.8,88.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M870.81,117.4h0a1.08,1.08,0,0,1-1-1.11l.25-8.41-5.38-.14h0a9.2,9.2,0,0,1-3.41-.92L851.28,102a3.6,3.6,0,0,1,3.05-6.53l8.28,3.87a7.27,7.27,0,0,0,3.47.66h7.7a1.08,1.08,0,1,1,0,2.16h-7.6a9.33,9.33,0,0,1-4.48-.86l-8.27-3.86a1.44,1.44,0,0,0-1.88.66,1.46,1.46,0,0,0,.67,2l9.87,4.8a7.12,7.12,0,0,0,2.6.69l6.43.18a1.08,1.08,0,0,1,1,1.11l-.29,9.48A1.07,1.07,0,0,1,870.81,117.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M884.89,117.4a1.08,1.08,0,0,1-1.08-1.05l-.29-9.48a1.09,1.09,0,0,1,1.05-1.11l6.44-.18a7.07,7.07,0,0,0,2.59-.69l9.87-4.8a1.45,1.45,0,0,0-1.22-2.63L894,101.32a9.39,9.39,0,0,1-4.49.86H882a1.08,1.08,0,0,1,0-2.16h7.64a7.27,7.27,0,0,0,3.47-.66l8.27-3.87a3.61,3.61,0,0,1,3,6.54l-9.85,4.78a9.25,9.25,0,0,1-3.41.92h0l-5.38.14.25,8.41a1.08,1.08,0,0,1-1,1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M856.26,97.27H842.9a1.07,1.07,0,0,1-1.08-1.07V79A1.08,1.08,0,0,1,842.9,78h13.36A1.08,1.08,0,0,1,857.34,79V96.2A1.08,1.08,0,0,1,856.26,97.27ZM844,95.12h11.21v-15H844Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M852.2,84.35H847a1.08,1.08,0,0,1,0-2.16h5.17a1.08,1.08,0,1,1,0,2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M852.2,88.44H847a1.08,1.08,0,0,1,0-2.16h5.17a1.08,1.08,0,1,1,0,2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M849,92.53h-2a1.08,1.08,0,1,1,0-2.15h2a1.08,1.08,0,1,1,0,2.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M912,97.27H898.64a1.07,1.07,0,0,1-1.07-1.07V79A1.07,1.07,0,0,1,898.64,78H912A1.07,1.07,0,0,1,913.08,79V96.2A1.07,1.07,0,0,1,912,97.27Zm-12.29-2.15h11.21v-15H899.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M908,84.35h-5.18a1.08,1.08,0,0,1,0-2.16H908a1.08,1.08,0,0,1,0,2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M908,88.44h-5.18a1.08,1.08,0,0,1,0-2.16H908a1.08,1.08,0,0,1,0,2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M904.79,92.53h-2a1.08,1.08,0,0,1,0-2.15h2a1.08,1.08,0,0,1,0,2.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M872.21,73.57H858.85a1.08,1.08,0,0,1-1.08-1.08V55.32a1.08,1.08,0,0,1,1.08-1.08h13.36a1.08,1.08,0,0,1,1.07,1.08V72.49A1.08,1.08,0,0,1,872.21,73.57Zm-12.29-2.16h11.21v-15H859.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M868.15,60.64H863a1.08,1.08,0,0,1,0-2.16h5.17a1.08,1.08,0,1,1,0,2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M868.15,64.73H863a1.08,1.08,0,1,1,0-2.15h5.17a1.08,1.08,0,1,1,0,2.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M865,68.83h-2a1.08,1.08,0,0,1,0-2.16h2a1.08,1.08,0,0,1,0,2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M896.49,73.57H883.13a1.08,1.08,0,0,1-1.08-1.08V55.32a1.08,1.08,0,0,1,1.08-1.08h13.36a1.09,1.09,0,0,1,1.08,1.08V72.49A1.09,1.09,0,0,1,896.49,73.57ZM884.2,71.41h11.21v-15H884.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M892.43,60.64h-5.17a1.08,1.08,0,0,1,0-2.16h5.17a1.08,1.08,0,1,1,0,2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M892.43,64.73h-5.17a1.08,1.08,0,1,1,0-2.15h5.17a1.08,1.08,0,1,1,0,2.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M889.27,68.83h-2a1.08,1.08,0,0,1,0-2.16h2a1.08,1.08,0,1,1,0,2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M869,98.39a1.06,1.06,0,0,1-.91-.51l-5.35-8.53a5.54,5.54,0,0,1-.85-3V76.11a3.45,3.45,0,0,1,6.89,0v8.6a3.46,3.46,0,0,0,.72,2.09l.63.78a1.08,1.08,0,0,1-1.69,1.35l-.63-.8a5.54,5.54,0,0,1-1.18-3.42v-8.6a1.3,1.3,0,0,0-2.59,0V86.39a3.4,3.4,0,0,0,.52,1.81L870,96.74a1.07,1.07,0,0,1-.34,1.48A1.11,1.11,0,0,1,869,98.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M886.13,98.39a1.11,1.11,0,0,1-.57-.17,1.08,1.08,0,0,1-.34-1.48l5.35-8.54a3.4,3.4,0,0,0,.52-1.81V76.11a1.29,1.29,0,0,0-2.58,0v8.6a5.55,5.55,0,0,1-1.18,3.41l0,0-.78.94a1.07,1.07,0,0,1-1.51.14,1.09,1.09,0,0,1-.15-1.52l.77-.93a3.39,3.39,0,0,0,.71-2.07v-8.6a3.45,3.45,0,0,1,6.9,0V86.39a5.63,5.63,0,0,1-.85,3l-5.35,8.53A1.09,1.09,0,0,1,886.13,98.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M872.21,61.68a1.07,1.07,0,0,1-.2-2.13A32.06,32.06,0,0,1,877.8,59c.54,0,1.08,0,1.6,0a1.08,1.08,0,1,1-.1,2.15c-.5,0-1,0-1.5,0a30.47,30.47,0,0,0-5.4.49A.62.62,0,0,1,872.21,61.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M851.73,75.75a1.07,1.07,0,0,1-.92-1.64,31.5,31.5,0,0,1,7.37-8.28,1.08,1.08,0,1,1,1.33,1.69,29.63,29.63,0,0,0-6.87,7.72A1.06,1.06,0,0,1,851.73,75.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M877.8,122.38a31.68,31.68,0,0,1-27.49-15.93,1.08,1.08,0,0,1,1.87-1.07,29.54,29.54,0,0,0,50.69.93,1.07,1.07,0,0,1,1.82,1.14,31.6,31.6,0,0,1-26.89,14.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M906,79.86a1.06,1.06,0,0,1-1-.65,29.71,29.71,0,0,0-4.83-7.78,1.07,1.07,0,1,1,1.63-1.4A31.31,31.31,0,0,1,907,78.37a1.07,1.07,0,0,1-.57,1.41A1,1,0,0,1,906,79.86Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 495.9,
    y: 37.37,
    width: 101.89,
    height: 101.89,
    rx: 8.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M589.19,139.26H504.51a8.62,8.62,0,0,1-8.61-8.61V46a8.61,8.61,0,0,1,8.61-8.6h84.68a8.61,8.61,0,0,1,8.6,8.6v84.68A8.61,8.61,0,0,1,589.19,139.26ZM504.51,40.08A5.89,5.89,0,0,0,498.62,46v84.68a5.89,5.89,0,0,0,5.89,5.89h84.68a5.89,5.89,0,0,0,5.89-5.89V46a5.89,5.89,0,0,0-5.89-5.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M519.6,86.93a1.07,1.07,0,0,1-1-.67,4.41,4.41,0,0,1,1-4.79,2.26,2.26,0,0,0-1.6-3.86,4.42,4.42,0,0,1,0-8.84,2.26,2.26,0,0,0,1.6-3.86,4.42,4.42,0,0,1,6.24-6.25h0a2.26,2.26,0,0,0,3.86-1.6,4.42,4.42,0,1,1,8.84,0,2.26,2.26,0,0,0,3.86,1.6h0a4.38,4.38,0,0,1,3.11-1.29,4.42,4.42,0,0,1,3.13,7.54,2.19,2.19,0,0,0-.66,1.85,1.08,1.08,0,0,1-2.14.26,4.36,4.36,0,0,1,1.27-3.63,2.25,2.25,0,0,0,.66-1.6,2.21,2.21,0,0,0-.66-1.6,2.25,2.25,0,0,0-3.2,0h0a4.42,4.42,0,0,1-7.53-3.13,2.26,2.26,0,1,0-4.52,0,4.42,4.42,0,0,1-7.54,3.13h0a2.22,2.22,0,0,0-1.6-.67,2.27,2.27,0,0,0-1.6,3.87A4.42,4.42,0,0,1,518,70.93a2.26,2.26,0,1,0,0,4.52A4.42,4.42,0,0,1,521.09,83a2.27,2.27,0,0,0-.49,2.46,1.08,1.08,0,0,1-.6,1.4A1.14,1.14,0,0,1,519.6,86.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M527.81,119.38a16.34,16.34,0,1,1,0-32.68,1.08,1.08,0,1,1,0,2.15,14.19,14.19,0,1,0,0,28.38,1.08,1.08,0,1,1,0,2.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M527.81,114.7a11.68,11.68,0,0,1-10.19-6,1.08,1.08,0,0,1,.42-1.47,1.07,1.07,0,0,1,1.46.42,9.53,9.53,0,0,0,8.31,4.88,1.08,1.08,0,1,1,0,2.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M517.43,105.45a1.09,1.09,0,0,1-1.07-1,1.07,1.07,0,0,1,.93-1.2l9.44-1.21V91.72a1.08,1.08,0,0,1,2.16,0V103a1.08,1.08,0,0,1-.94,1.07l-10.38,1.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M558,124H536.9a5,5,0,0,1-5-5V75a5,5,0,0,1,5-5H558a5,5,0,0,1,5,5v44A5,5,0,0,1,558,124ZM536.9,72.11A2.87,2.87,0,0,0,534,75v44a2.86,2.86,0,0,0,2.87,2.86H558a2.86,2.86,0,0,0,2.87-2.86V75A2.87,2.87,0,0,0,558,72.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M543.72,103.15a1.09,1.09,0,0,1-.76-.32l-2.3-2.3a1.07,1.07,0,0,1,0-1.52,1.09,1.09,0,0,1,1.53,0l1.53,1.54,9.16-9.16a1.07,1.07,0,0,1,1.52,0,1.09,1.09,0,0,1,0,1.53l-9.91,9.91A1.09,1.09,0,0,1,543.72,103.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M548.39,120.39h-2.15a1.08,1.08,0,0,1,0-2.16h2.15a1.08,1.08,0,1,1,0,2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M558.16,76.42H536.61a1.08,1.08,0,1,1,0-2.15h21.55a1.08,1.08,0,1,1,0,2.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M558.16,116.65H536.61a1.08,1.08,0,1,1,0-2.15h21.55a1.08,1.08,0,1,1,0,2.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M575.13,91.11A1.07,1.07,0,0,1,574.06,90V61.48H556.9v5.39a1.08,1.08,0,1,1-2.16,0V60.4a1.07,1.07,0,0,1,1.08-1.07h19.31a1.07,1.07,0,0,1,1.08,1.07V90A1.08,1.08,0,0,1,575.13,91.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M570.42,72.53H560a1.08,1.08,0,0,1,0-2.16h10.46a1.08,1.08,0,0,1,0,2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M570.42,78h-8.06a1.08,1.08,0,0,1,0-2.16h8.06a1.08,1.08,0,0,1,0,2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M570.45,83.41h-8.09a1.08,1.08,0,0,1,0-2.15h8.09a1.08,1.08,0,1,1,0,2.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M566,88.86h-3.63a1.08,1.08,0,0,1,0-2.16H566a1.08,1.08,0,1,1,0,2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M570.42,67.08h-9.64a1.08,1.08,0,0,1,0-2.15h9.64a1.08,1.08,0,0,1,0,2.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M581.15,113.54H562a1.08,1.08,0,0,1,0-2.16h18.1V97.75L570.1,93l-7.66,3.68a1.08,1.08,0,0,1-.94-1.94l8.13-3.9a1,1,0,0,1,.93,0l11.06,5.3a1.09,1.09,0,0,1,.61,1v15.39A1.08,1.08,0,0,1,581.15,113.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M570.19,104.87a1.09,1.09,0,0,1-.56-.15L561.71,100a1.08,1.08,0,1,1,1.1-1.85l7.37,4.4,10.41-6.38A1.08,1.08,0,0,1,581.72,98l-11,6.72A1,1,0,0,1,570.19,104.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M529.4,80.44a1,1,0,0,1-.65-.22,8.77,8.77,0,0,1-3.49-7,8.83,8.83,0,0,1,14.82-6.5,1.08,1.08,0,0,1-1.46,1.58,6.68,6.68,0,1,0-8.57,10.24,1.07,1.07,0,0,1,.21,1.51A1.09,1.09,0,0,1,529.4,80.44Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 330.6,
    y: 37.37,
    width: 101.89,
    height: 101.89,
    rx: 8.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M425.89,139.26H341.21a8.62,8.62,0,0,1-8.61-8.61V46a8.61,8.61,0,0,1,8.61-8.6h84.68a8.61,8.61,0,0,1,8.6,8.6v84.68A8.61,8.61,0,0,1,425.89,139.26ZM341.21,40.08A5.89,5.89,0,0,0,335.32,46v84.68a5.89,5.89,0,0,0,5.89,5.89h84.68a5.9,5.9,0,0,0,5.89-5.89V46a5.9,5.9,0,0,0-5.89-5.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M400.41,115.45h-36.9a1.13,1.13,0,1,1,0-2.26h36.9a1.13,1.13,0,0,1,0,2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M356.94,122.09A1.14,1.14,0,0,1,355.8,121V109.49a1.14,1.14,0,0,1,2.27,0V121A1.14,1.14,0,0,1,356.94,122.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M355.38,99a6.41,6.41,0,0,1-6.4-6.4v-1.5a6.4,6.4,0,1,1,12.8,0v1.5A6.41,6.41,0,0,1,355.38,99Zm0-12a4.13,4.13,0,0,0-4.13,4.13v1.5a4.14,4.14,0,1,0,8.27,0v-1.5A4.14,4.14,0,0,0,355.38,87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M344.71,122a1.13,1.13,0,0,1-1.13-1.13l0-14.26a9.78,9.78,0,0,1,9.77-9.79h.87a6.91,6.91,0,0,1,5.23,2.4l7,8.2,5.5,0h0a2.29,2.29,0,0,1,2.29,2.28,5.86,5.86,0,0,1-5.85,5.85h-6a4,4,0,0,1-3.07-1.43l-6.55-7.82a1.13,1.13,0,0,1,.14-1.59,1.14,1.14,0,0,1,1.6.14l6.54,7.81a1.73,1.73,0,0,0,1.34.63h6a3.59,3.59,0,0,0,3.58-3.59l-6,0a1.07,1.07,0,0,1-.87-.4l-7.37-8.59A4.61,4.61,0,0,0,354.2,99h-.87a7.53,7.53,0,0,0-7.51,7.52l0,14.27a1.13,1.13,0,0,1-1.13,1.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M406.15,122.09A1.14,1.14,0,0,1,405,121V109.49a1.14,1.14,0,0,1,2.27,0V121A1.14,1.14,0,0,1,406.15,122.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M407.74,99h-.06a6.41,6.41,0,0,1-6.4-6.4V90.82a6.43,6.43,0,0,1,12.86,0v1.82A6.41,6.41,0,0,1,407.74,99Zm0-12.35a4.14,4.14,0,0,0-4.19,4.13v1.82a4.14,4.14,0,0,0,4.13,4.14h.06a4.15,4.15,0,0,0,4.14-4.14V90.82A4.14,4.14,0,0,0,407.74,86.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M418.38,122h0a1.12,1.12,0,0,1-1.13-1.13l0-14.27A7.51,7.51,0,0,0,409.76,99h-.86a4.62,4.62,0,0,0-3.52,1.62L398,109.25a1,1,0,0,1-.86.4l-6-.05a3.57,3.57,0,0,0,3.57,3.61h6a1.73,1.73,0,0,0,1.34-.63l6.55-7.81a1.13,1.13,0,1,1,1.73,1.45L403.79,114a4,4,0,0,1-3.08,1.43h-6a5.85,5.85,0,0,1-5.85-5.85,2.29,2.29,0,0,1,.67-1.62,2.42,2.42,0,0,1,1.63-.66l5.5,0,7-8.2a6.93,6.93,0,0,1,5.24-2.4h.86a9.78,9.78,0,0,1,9.78,9.79l0,14.26A1.12,1.12,0,0,1,418.38,122Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M406.42,81.93a1.13,1.13,0,0,1-1.13-1.13v-24H357.9v24a1.14,1.14,0,0,1-2.27,0V55.67a1.13,1.13,0,0,1,1.13-1.13h49.66a1.13,1.13,0,0,1,1.14,1.13V80.8A1.13,1.13,0,0,1,406.42,81.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M397.87,96.37H365.32a1.13,1.13,0,1,1,0-2.26h32.55a1.13,1.13,0,0,1,0,2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M393.32,90.31a1.14,1.14,0,0,1-1.13-1.13v-3.9a5.06,5.06,0,0,0-3.54-4.84l-.14,0a21,21,0,0,0-12.74,0l-.15,0a5.07,5.07,0,0,0-3.54,4.84v3.9a1.13,1.13,0,0,1-2.26,0v-3.9a7.32,7.32,0,0,1,5.12-7l.14,0a23.12,23.12,0,0,1,14.11,0l.14,0a7.31,7.31,0,0,1,5.12,7v3.9A1.13,1.13,0,0,1,393.32,90.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M382.15,79.41a7.1,7.1,0,0,1-7.09-7.09V69.71a7.09,7.09,0,1,1,14.17,0v2.61A7.1,7.1,0,0,1,382.15,79.41Zm0-14.52a4.83,4.83,0,0,0-4.83,4.82v2.61a4.83,4.83,0,0,0,9.65,0V69.71A4.83,4.83,0,0,0,382.15,64.89Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 0.03,
    y: 37.44,
    width: 101.89,
    height: 101.89,
    rx: 8.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M93.29,37.37a8.61,8.61,0,0,1,8.6,8.6v84.68a8.61,8.61,0,0,1-8.6,8.61H8.6A8.61,8.61,0,0,1,0,130.65V46a8.61,8.61,0,0,1,8.6-8.6m0,2.71A5.89,5.89,0,0,0,2.72,46v84.68a5.89,5.89,0,0,0,5.88,5.89H93.29a5.89,5.89,0,0,0,5.88-5.89V46a5.89,5.89,0,0,0-5.88-5.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M30.19,74.85h-14a1.08,1.08,0,0,1-1.08-1.08v-18a1.08,1.08,0,0,1,1.08-1.08h14a1.08,1.08,0,0,1,1.08,1.08v18A1.08,1.08,0,0,1,30.19,74.85ZM17.28,72.69H29.11V56.88H17.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M25.94,61.32H20.53a1.08,1.08,0,0,1,0-2.16h5.41a1.08,1.08,0,0,1,0,2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M25.94,65.6H20.53a1.08,1.08,0,1,1,0-2.15h5.41a1.08,1.08,0,1,1,0,2.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M22.63,69.89h-2.1a1.08,1.08,0,0,1,0-2.16h2.1a1.08,1.08,0,1,1,0,2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M48.69,74.85h-14a1.07,1.07,0,0,1-1.07-1.08v-18a1.08,1.08,0,0,1,1.07-1.08h14a1.09,1.09,0,0,1,1.08,1.08v18A1.08,1.08,0,0,1,48.69,74.85ZM35.78,72.69H47.61V56.88H35.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M44.44,61.32H39a1.08,1.08,0,0,1,0-2.16h5.41a1.08,1.08,0,0,1,0,2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M44.44,65.6H39a1.08,1.08,0,1,1,0-2.15h5.41a1.08,1.08,0,1,1,0,2.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M41.13,69.89H39a1.08,1.08,0,0,1,0-2.16h2.1a1.08,1.08,0,1,1,0,2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M67.19,74.85h-14a1.08,1.08,0,0,1-1.08-1.08v-18a1.09,1.09,0,0,1,1.08-1.08h14a1.09,1.09,0,0,1,1.08,1.08v18A1.08,1.08,0,0,1,67.19,74.85ZM54.28,72.69H66.11V56.88H54.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M62.94,61.32H57.53a1.08,1.08,0,0,1,0-2.16h5.41a1.08,1.08,0,0,1,0,2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M62.94,65.6H57.53a1.08,1.08,0,1,1,0-2.15h5.41a1.08,1.08,0,1,1,0,2.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M59.63,69.89h-2.1a1.08,1.08,0,0,1,0-2.16h2.1a1.08,1.08,0,0,1,0,2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M85.69,74.85h-14a1.08,1.08,0,0,1-1.08-1.08v-18a1.08,1.08,0,0,1,1.08-1.08h14a1.08,1.08,0,0,1,1.07,1.08v18A1.07,1.07,0,0,1,85.69,74.85ZM72.78,72.69H84.61V56.88H72.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M81.44,61.32H76a1.08,1.08,0,0,1,0-2.16h5.42a1.08,1.08,0,0,1,0,2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M81.44,65.6H76a1.08,1.08,0,0,1,0-2.15h5.42a1.08,1.08,0,0,1,0,2.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M78.13,69.89H76a1.08,1.08,0,0,1,0-2.16h2.11a1.08,1.08,0,0,1,0,2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M53.2,109.72h-.07a1.26,1.26,0,0,1-1.16-.8l-.79-2.06h-5l-.74,2a1.25,1.25,0,0,1-1.17.82h0a1.24,1.24,0,0,1-1.16-1.7l3.74-9.62a2,2,0,0,1,1.84-1.25h0a2,2,0,0,1,1.83,1.24L54.36,108A1.25,1.25,0,0,1,53.2,109.72Zm-2.83-5-1.47-4a.28.28,0,0,0-.52,0l-1.44,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M56.31,108.47V98.39a1.25,1.25,0,0,1,1.24-1.24h.05a1.25,1.25,0,0,1,1.25,1.24v10.08a1.25,1.25,0,0,1-1.25,1.25h-.05A1.25,1.25,0,0,1,56.31,108.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M74.56,116.88H27.38a1.08,1.08,0,0,1-1.08-1.08V88.36a1.08,1.08,0,0,1,1.08-1.08H74.56a1.08,1.08,0,0,1,1.08,1.08V115.8A1.08,1.08,0,0,1,74.56,116.88Zm-46.1-2.16h45V89.43h-45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M85.55,126.65H16.39a1.08,1.08,0,0,1-.71-1.89l11-9.77a1.13,1.13,0,0,1,.72-.27H74.56a1.11,1.11,0,0,1,.72.27l11,9.77a1.08,1.08,0,0,1-.71,1.89Zm-66.32-2.16H82.72l-8.57-7.61H27.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M51.78,92.88H50.16a1.08,1.08,0,1,1,0-2.15h1.62a1.08,1.08,0,1,1,0,2.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M61.11,123.05H40.84a1.08,1.08,0,1,1,0-2.15H61.11a1.08,1.08,0,0,1,0,2.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M51,89.43a1.07,1.07,0,0,1-1.08-1.07V86.22a2.62,2.62,0,0,0-2.62-2.61H26.94a4.78,4.78,0,0,1-4.77-4.78V74.16a1.08,1.08,0,1,1,2.15,0v4.67a2.62,2.62,0,0,0,2.62,2.62H47.28a4.78,4.78,0,0,1,4.77,4.77v2.14A1.07,1.07,0,0,1,51,89.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M51.05,89.39A1.08,1.08,0,0,1,50,88.31V86.22a4.78,4.78,0,0,1,4.77-4.77H75a2.61,2.61,0,0,0,2.61-2.62V73.77a1.08,1.08,0,0,1,2.16,0v5.06A4.78,4.78,0,0,1,75,83.61H54.74a2.62,2.62,0,0,0-2.62,2.61v2.09A1.07,1.07,0,0,1,51.05,89.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M41.73,83.61a1.08,1.08,0,0,1-1.07-1.08V73.88a1.08,1.08,0,1,1,2.15,0v8.65A1.08,1.08,0,0,1,41.73,83.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M59.69,83.61a1.08,1.08,0,0,1-1.07-1.08V73.88a1.08,1.08,0,1,1,2.15,0v8.65A1.08,1.08,0,0,1,59.69,83.61Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 991.81,
    y: 37.37,
    width: 101.89,
    height: 101.89,
    rx: 8.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "M1085.09,139.26h-84.68a8.61,8.61,0,0,1-8.6-8.61V46a8.61,8.61,0,0,1,8.6-8.6h84.68a8.61,8.61,0,0,1,8.61,8.6v84.68A8.62,8.62,0,0,1,1085.09,139.26Zm-84.68-99.18A5.9,5.9,0,0,0,994.52,46v84.68a5.9,5.9,0,0,0,5.89,5.89h84.68a5.89,5.89,0,0,0,5.89-5.89V46a5.89,5.89,0,0,0-5.89-5.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "M1049.73,82.23h-19.34a1.19,1.19,0,0,1,0-2.38h19.34a1.19,1.19,0,0,1,0,2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "M1049.73,87.08h-19.34a1.19,1.19,0,0,1,0-2.38h19.34a1.19,1.19,0,0,1,0,2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M1045.55,91.93h-11.64a1.19,1.19,0,0,1,0-2.38h11.64a1.19,1.19,0,1,1,0,2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M1066.09,122.64H1056a10.08,10.08,0,0,1-4.65-1.37c-.22-.13-.45-.25-.68-.36a1.19,1.19,0,1,1,1.08-2.12l.8.44a7.7,7.7,0,0,0,3.45,1h10.12a.64.64,0,0,0,.64-.63v-.11a.64.64,0,0,0-.64-.64,1.19,1.19,0,0,1,0-2.38h1.8a.64.64,0,0,0,.64-.63.65.65,0,0,0-.64-.68,1.19,1.19,0,0,1,0-2.37h1a1.07,1.07,0,0,0,1.07-1.07,1.08,1.08,0,0,0-1.07-1.12h-.35a1.19,1.19,0,1,1,0-2.37,1.09,1.09,0,0,0,0-2.18h-7.69a1.18,1.18,0,0,1-1.11-1.61,9.63,9.63,0,0,0,0-5.46c-.69-1.32-1.46-2.16-2.11-2.3h0a25.66,25.66,0,0,1,0,4.39,1,1,0,0,1-.11.39c-1.06,2.16-2.35,4.54-4,5.85a6.53,6.53,0,0,1-2,1,1.19,1.19,0,1,1-.76-2.25,4.1,4.1,0,0,0,1.28-.63c1.34-1.1,2.62-3.61,3.23-4.86a29.51,29.51,0,0,0-.11-4.68,1.22,1.22,0,0,1,.45-1.07,3.17,3.17,0,0,1,2.53-.49c1.42.31,2.68,1.53,3.75,3.61a1.22,1.22,0,0,1,.07.17,12.73,12.73,0,0,1,.41,5.53h6.16a3.45,3.45,0,0,1,3.44,3.45,3.51,3.51,0,0,1-.68,2.09,3.43,3.43,0,0,1,1,2.46,3.51,3.51,0,0,1-1.68,3,2.94,2.94,0,0,1,.21,1.12,3,3,0,0,1-1.92,2.84,3,3,0,0,1,.12.85v.11A3,3,0,0,1,1066.09,122.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M1051.18,121.8h-5.63a1.19,1.19,0,0,1-1.19-1.19V106.28a1.19,1.19,0,0,1,1.19-1.19h5.63a1.19,1.19,0,0,1,1.19,1.19v14.33A1.19,1.19,0,0,1,1051.18,121.8Zm-4.44-2.38H1050v-12h-3.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "M1058.81,109.07a1.23,1.23,0,0,1-.89-.4A1.2,1.2,0,0,1,1058,107a13.25,13.25,0,0,0,1.8-2.67,1.19,1.19,0,0,1,2.09,1.14,15.51,15.51,0,0,1-2.32,3.31A1.2,1.2,0,0,1,1058.81,109.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M1042.11,118.74H1020a3.25,3.25,0,0,1-3.23-3.25V59.29A3.25,3.25,0,0,1,1020,56h40.2a3.25,3.25,0,0,1,3.23,3.25V94.81a1.19,1.19,0,0,1-2.38,0V59.29a.86.86,0,0,0-.85-.87H1020a.86.86,0,0,0-.85.87v56.2a.87.87,0,0,0,.85.88h22.15a1.19,1.19,0,1,1,0,2.37Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyFunctionNew);
export default __webpack_public_path__ + "static/media/key-function-new.f8612ae094e55e6700c2e9226fe71c83.svg";
export { ForwardRef as ReactComponent };